/**
 * form
 *
 * @author Shigq
 * @date 2021/4/20 10:37
 */
import { reactive } from 'vue'
import { utils } from '@libs/dep-private'

const { currencyUtils, commonUtils, validator } = utils

/**
 * assemble form
 *
 * @param items
 * @returns {{rules: {}, fields: {}}}
 */

const assembleForm = function (items) {
	const _fields = {}
	const _rules = {}
	const _schema = {}

	try {
		if (items && items.length > 0) {
			items.forEach(item => {
				if (item) {
					_fields[item.prop] = item.default
					_schema[item.prop] = item

					const rules = item.rules

					if (rules) {
						_rules[item.prop] = rules
					}
				}
			})
		}

		return {
			fields: _fields,
			rules: _rules,
			schema: _schema
		}
	} catch (e) {
		throw new Error(`form.js#assembleForm failed! \n ${e.toString()}`)
	}
}

export default function () {
	// todo - methods
	const scopedMethods = {
		/**
		 * create form
		 *
		 * @param items
		 * @returns {*}
		 */
		createForm: ({ items = [] } = {}) => {
			/* 保证数据原子性 */
			const currItems = commonUtils.clone(items)

			const { fields, rules, schema } = assembleForm(currItems)

			return reactive({
				fields,
				rules,
				schema,
				items
			})
		},
		/**
		 * setForm form
		 *
		 * @param form
		 * @param target
		 */
		setForm: (form, target) => {
			Object.keys(form.fields).forEach(item => {
				form.fields[item] = target[item]
			})
		},
		/**
		 * reset form
		 *
		 * @param form
		 */
		resetForm: form => {
			Object.keys(form.fields).forEach(item => {
				form.fields[item] = form.schema[item]?.default
			})
		},
		/**
		 * reset form by fields
		 *
		 * @param form
		 */
		resetFormByFields: (form, fields) => {
			Object.keys(form.fields).forEach(item => {
				if (fields.includes(item)) {
					form.fields[item] = form.schema[item].default
				}
			})
		},
		setFormItem: (form, field, attr, value) => {
			form.items.filter(item => {
				return item.prop === field
			})[0][attr] = value
		}
	}

	// todo - handle
	const scopedHandlers = {
		handleAmountFocus(target, attr) {
			target[attr] = currencyUtils.reformatMoney(target[attr])
		},
		handleAmountBlur(target, attr) {
			if (!validator.isPositiveNumber(target[attr])) {
				target[attr] = ''
				return
			}
			target[attr] = currencyUtils.formatMoney(target[attr], 2, '')
		}
	}

	return {
		...scopedMethods,
		...scopedHandlers
	}
}
